import * as React from 'react';
export const multibancoSvg = React.forwardRef(function multibancoSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M0 0h32v32H0z',
        fill: '#2e333a',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M15.842 25.89h8.734c1.995 0 2.014-2.124 1.811-3.173-.11-.705-1.306-.7-1.438 0v.818a.68.68 0 0 1-.678.68H7.525a.681.681 0 0 1-.679-.68v-.818c-.131-.7-1.327-.705-1.438 0-.203 1.049-.183 3.173 1.812 3.173h7.947zm6.617-20.35h.675c.947 0 1.72.821 1.72 1.825v.872c0 1.233-1.666 1.228-1.666.008V7.77a.552.552 0 0 0-.55-.55H9.143a.552.552 0 0 0-.55.55v.467c0 1.226-1.588 1.217-1.588.026v-.897c0-1.004.774-1.825 1.72-1.825h.941z',
        fill: '#3a74c4',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M24.515 15.564c.933.44 1.577 1.348 1.577 2.39 0 1.47-1.28 2.672-2.846 2.672h-4.385c-.41 0-.746-.315-.746-.7v-8.364c0-.403.33-.734.732-.734h3.654a2.806 2.806 0 0 1 2.796 2.8c0 .75-.299 1.432-.782 1.936m-3.274-.681a.772.772 0 0 0-.769.77c0 .424.346.77.77.77h1.392v.004h.551c.753 0 1.368.617 1.368 1.37 0 .755-.615 1.372-1.368 1.372h-3.557v-6.94h2.805a1.33 1.33 0 0 1 1.325 1.326 1.33 1.33 0 0 1-1.124 1.312v.016zm-3.823 4.908a.88.88 0 0 1-1.75.186l-.722-6.651-2.554 6.503-.003.006v.001l-.007.017-.006.014-.001.003-.006.014-.004.008-.006.013-.003.006-.007.013-.002.005a.877.877 0 0 1-.179.233l-.002.002-.014.012a.87.87 0 0 1-.152.108l-.004.002-.016.01-.016.008-.007.003-.01.005-.01.005-.01.004-.011.005-.01.004-.008.004-.009.003-.004.002-.008.002-.011.005-.007.002a.875.875 0 0 1-.258.049h-.064a.875.875 0 0 1-.288-.06l-.012-.005-.003-.001-.012-.005-.011-.005-.01-.004-.01-.005-.01-.005-.006-.003-.016-.008-.002-.001-.013-.008-.008-.004a.877.877 0 0 1-.135-.094l-.003-.002-.03-.026a.85.85 0 0 1-.022-.022l-.021-.022a.836.836 0 0 1-.026-.03l-.003-.003a.879.879 0 0 1-.093-.135l-.005-.008-.007-.014-.001-.001-.008-.016-.003-.006-.005-.01-.005-.01-.004-.01-.005-.011-.005-.012-.001-.003-.005-.012-2.557-6.51-.722 6.651a.88.88 0 1 1-1.75-.186l.85-7.842v-.002l.001-.003a1.465 1.465 0 0 1 1.257-1.289h.002l.048-.005c.075-.008.149-.01.222-.007h.003a1.446 1.446 0 0 1 1.289.922l2.177 5.541 2.176-5.541a1.446 1.446 0 0 1 1.29-.922h.003a1.473 1.473 0 0 1 .27.012h.002a1.459 1.459 0 0 1 1.257 1.288v.006z',
        fill: '#fff',
      }),
    ),
  );
});
multibancoSvg.defaultProps = {
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var multibanco = {
  category: 'brand',
  colorable: false,
  name: 'multibanco',
  svg: multibancoSvg,
};
